import React from "react";
import { useHistory } from "react-router-dom";

const Redirection: React.FC = () => {
  const { location } = useHistory();
  const queryParam = new URLSearchParams(location.search);
  const fi = queryParam.get("fi");
  const reqdate = queryParam.get("resdate");
  const ecreq = queryParam.get("ecres");

  return (
    <div>
      fi: {fi}, resdate: {reqdate}, ecres: {ecreq}
    </div>
  );
};

export default Redirection;
